
















































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import { EventBus } from "@/eventbus";
export default Vue.extend({
  props: ["source"],
  components: {
    AppTableRow,
  },
  setup(props) {
    const showMenu = (event: MouseEvent) =>
      EventBus.emit("showReportMenu", { item: props.source, event });

    return {
      showMenu,
    };
  },
});
